/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState } from 'react';
import CARMO_CONST from '@/common/util/const';
import API from '@/common/util/api';
import { StandardProps } from '@/newcar/ui/contract';
import SearchResultList from '@/newcar/ui/contract/components/SearchResultList';
import LoadingButton from '@/newcar/ui/contract/components/LoadingButton';
import * as styles from './index.module.styl';

interface AddressProps extends StandardProps {
  /**
   * 検索をしているEntityのID
   * @required
   * @type {string}
   * @memberof AddressProps
   */
  id: string;

  /**
   * モーダルの表示管理
   * @required
   * @type {boolean}
   * @memberof AddressProps
   */
  isActive: boolean;

  /**
   * ローディング表示管理
   * @required
   * @type {boolean}
   * @memberof AddressProps
   */
  isLoading: boolean;

  /**
   * 検索結果表示管理
   * @required
   * @type {boolean}
   * @memberof AddressProps
   */
  isShowResult: boolean;

  /**
   * 検索結果
   * @required
   * @type {API.IAddress[]}
   * @memberof AddressProps
   */
  addresses: API.IAddress[];

  /**
   * 検索リクエストのコールバック
   * @required
   * @type {Function}
   * @memberof AddressProps
   */
  handleRequestFindAddress: Function;

  /**
   * 閉じる押下時のコールバック
   * @required
   * @type {Function}
   * @memberof AddressProps
   */
  handleCloseModal: Function;

  /**
   * 検索に戻る押下時のコールバック
   * @required
   * @type {Function}
   * @memberof AddressProps
   */
  handleReturnSearch: Function;

  /**
   * 住所選択時のコールバック
   * @required
   * @type {Function}
   * @memberof AddressProps
   */
  handleSetAddress: Function;
}

// 住所検索（都道府県、市区町村）
export default function SearchAddressModal(props: AddressProps): JSX.Element {
  const {
    className = '',
    id = '',
    isActive,
    isLoading,
    isShowResult,
    addresses = [],
    handleCloseModal,
    handleSetAddress,
    handleReturnSearch,
    handleRequestFindAddress,
  } = props;

  // State
  const [prefecture, setPrefecture] = useState<string>('');
  const [cities, setCities] = useState<string>('');

  // 検索結果から１つ選択したときのコールバック
  const handleSetIdAndAddress = (result: API.IAddress) => {
    handleSetAddress(id, result);
  };

  // 都道府県の選択ハンドラ
  const handlerPrefecture = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setPrefecture(event.target.value);
  };
  // 市区町村の変更ハンドラ
  const handlerCities = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCities(event.target.value);
  };

  // 検索ボタン押下
  const onClickSearchButton = (_: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    handleRequestFindAddress(id, prefecture, cities);
  };

  // 都道府県の入力チェック
  const isSelectInvalid = () => Boolean(prefecture === '');

  // 都道府県の入力チェック
  const isCitiesInvalid = () => Boolean(cities === '');

  return (
    <div className={className}>
      <div className={`modal ${isActive ? 'is-active' : ''}`}>
        <div
          className="modal-background"
          role="button"
          tabIndex={-1}
          onClick={() => handleCloseModal()}
        />
        <div className="modal-content is-padding-6-tablet">
          <div className="box radius-mini">
            <div className="content is-size-5 is-padding-4">
              <a
                onMouseDown={() => handleCloseModal()}
                className="is-pulled-right"
                data-gtm="gtm-newcarform-addressModal-close"
                role="button"
              >
                閉じる
              </a>
              {isShowResult && addresses.length > 0 ? (
                <>
                  <p className="title">住所を以下よりお選びください</p>
                  <div className="columns is-multiline">
                    <div className={`column is-full ${styles.addresslist_paging}`}>
                      <p className="is-pulled-right">
                        <a
                          onClick={() => handleReturnSearch()}
                        >
                          検索に戻る
                        </a>
                      </p>
                    </div>
                    <SearchResultList handleSetAddress={handleSetIdAndAddress} items={addresses} />
                  </div>
                </>
              ) : (
                <>
                  <p className="is-size-3"><strong>住所から検索</strong></p>
                  {isShowResult && addresses.length === 0
                    ? <p className="is-margin-bottom-3 has-text-danger">候補が見つかりませんでした。検索しなおしてください。</p>
                    : <></>}
                  <p className="is-margin-bottom-3 has-text-weight-bold">都道府県と市区町村・町名を入力してください。</p>
                  <div className="columns is-multiline">
                    <div className="column is-full is-padding-top-3 is-padding-bottom-3">
                      <div className="is-margin-bottom-3">都道府県</div>
                      <div
                        className={`${styles.pFormField} ${styles.cSelect}`}
                        aria-invalid={isSelectInvalid()}
                        aria-required="true"
                      >
                        <div className={styles.cSelectBody}>
                          <select
                            id="searchAddress_prefecture"
                            className="is-size-4"
                            data-gtm="gtm-newcarform-prefecture"
                            onChange={handlerPrefecture}
                          >
                            <option value="">選択してください</option>
                            {
                              CARMO_CONST.PREFECTURES.DATA.map((item) => (
                                <option key={`${id}-${item}`} value={item ?? ''}>
                                  {item}
                                </option>
                              ))
                            }
                          </select>
                          <i className={styles.iconPulldown} />
                        </div>
                      </div>
                    </div>
                    <div className="column is-full">
                      <div className="is-padding-top-3 is-padding-bottom-3">
                        <div className="is-margin-bottom-3">市区町村・町名</div>
                        <div
                          className={styles.cInput}
                          aria-invalid={isCitiesInvalid()}
                          aria-required="true"
                        >
                          <div className={styles.cInputInner}>
                            <input
                              id="searchAddress_cities"
                              className={`${styles.cInputField} is-size-4`}
                              type="text"
                              placeholder="例：豊島区東五反田"
                              data-gtm="gtm-newcarform-cities"
                              onChange={handlerCities}
                            />
                            <a
                              className="c-input__clear"
                              tabIndex={-1}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="column is-full">
                      <div className="is-padding-top-3 is-padding-bottom-3">
                        <LoadingButton
                          className={styles.addressButton_loading}
                          loading={isLoading}
                          gtm="gtm-newcarform-addressModalSearch"
                          size="small"
                          disabled={isSelectInvalid() || isCitiesInvalid() || isLoading}
                          onClick={onClickSearchButton}
                        >
                          <span className="is-size-4">
                            {isLoading ? '検索中・・・' : '検索'}
                          </span>
                        </LoadingButton>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
